import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SortConfig } from 'src/app/shared/view-models/sort-config';
import { PlayersView } from '../_models';
import { LocationDetailsRadioSortColumns } from '../location-details-sort-columns.enum';

@Component({
	selector: 'ld-location-details-radio-table',
	templateUrl: './location-details-radio-table.component.html'
})
export class LocationDetailsRadioTableComponent {
	@Input() tableData: PlayersView[];
	@Output() handleDeleteClick = new EventEmitter<PlayersView>();
	@Output() handleEditClick = new EventEmitter<PlayersView>();
	@Output() handleErrorLogsClick = new EventEmitter<PlayersView>();
	sortConfig: SortConfig = {
		column: LocationDetailsRadioSortColumns.NAME,
		direction: 'asc'
	};
	readonly sortColumns = LocationDetailsRadioSortColumns;

	constructor() {}

	public getSortIconClass(column: LocationDetailsRadioSortColumns): string {
		if (this.sortConfig.column !== column) {
			return 'fas fa-sort';
		}
		return this.sortConfig.direction === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
	}

	public onSort(newConfig: SortConfig) {
		this.sortConfig = newConfig;
	}

	public onEditClick(player: PlayersView): void {
		this.handleEditClick.emit(player);
	}

	public onDeleteClick(player: PlayersView): void {
		this.handleDeleteClick.emit(player);
	}

	public onErrorLogsClick(player: PlayersView): void {
		this.handleErrorLogsClick.emit(player);
	}

	public valueAccessor = (item: PlayersView, column: LocationDetailsRadioSortColumns) => {
		switch (column) {
			case LocationDetailsRadioSortColumns.MAC_ADDRESS:
				return item.MacAddress;
			case LocationDetailsRadioSortColumns.NAME:
				return item.PlayerName;
			case LocationDetailsRadioSortColumns.HOSTNAME:
				return item.Hostname;
			case LocationDetailsRadioSortColumns.MODEL:
				return item.PlayerModel.Name;
			case LocationDetailsRadioSortColumns.NOTES:
				return item.PlayerNotes;
			default:
				return '';
		}
	};
}
